export default {
footer: {
    ageRestriction: "当プラットフォームは18歳以上のユーザーのみを対象としています。ギャンブルは依存症になる恐れがあります。責任を持って、娯楽の範囲内でお楽しみください。詳細については、責任あるギャンブルのページをご覧ください。",
    followUs: "フォローする",
    company: "会社概要",
    legal: "法的記載",
    support: "サポート",
    gameProviders: "ゲームプロバイダー",
    copyright: "Copyright © 2019-2026 LOGO. All Rights Reserved.",
	documents: "書類・規約",
  }
}
